<section
  class="rs-toaster"
  [class.open]="open"
  role="dialog"
  attr.aria-labelledby="{{ id }}-title"
>
  <div class="rs-toaster-backdrop" (click)="onClose()"></div>
  <div class="rs-toaster-wrapper">
    <div class="rs-toaster-inner">
      <div class="rs-toaster-close">
        <button class="rs-link-action rs-link-action-close" (click)="onClose()">
          <span
            class="rs-action-link-icon"
            [title]="'common.toaster.close.caption' | translate"
          >
            <span class="show-for-sr">
              {{ "common.toaster.close.caption" | translate }}
            </span>
          </span>
        </button>
      </div>
      <header class="rs-toaster-header">
        <h2 id="{{ id }}-title" class="rs-has-subtit rs-tit1">
          {{ title }}
        </h2>
      </header>
      <div class="rs-toaster-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</section>
